import { render, staticRenderFns } from "./MailAttachmentList.vue?vue&type=template&id=04ca7deb&scoped=true"
import script from "./MailAttachmentList.vue?vue&type=script&lang=js"
export * from "./MailAttachmentList.vue?vue&type=script&lang=js"
import style0 from "./MailAttachmentList.vue?vue&type=style&index=0&id=04ca7deb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca7deb",
  null
  
)

export default component.exports